// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ptmqrrotertsedaudhvt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0bXFycm90ZXJ0c2VkYXVkaHZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1MTczNDksImV4cCI6MjA2MDA5MzM0OX0.ZqJpr_tp0RyTvC4NF1eM9rE51wBzK4kIDhFfv5yn-Ts";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);